module.exports = __webpack_public_path__ + "static/img/register-step-2.dccfd95.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/register-step-2.png
// module id = yyb4
// module chunks = 1